<template>
  <div id="uyh-app" :class="[{share: this.$store.state.share}, {'mantra-page': this.$store.state.mantrapage}, {'image-page': this.$route.path.includes('image')}, this.$i18n.locale]">
    <Loader v-if="loaderActive"/>
    <ImageUpload  v-if="galleryUpload"
                  @hide-gallery-upload="hideGalleryUpload"/>
    <TakePicture  v-if="takeImage"
                  @hide-take-picture="hideTakePicture"/>
    <Nav v-if="!this.$route.path.includes('next-steps') && !this.$route.path.includes('preview')" />
    <router-view  @loader-active="loaderOn"
                  @loader-inactive="loaderOff"
                  @show-gallery-upload="showGalleryUpload"
                  @show-take-picture="showTakePicture"/>
  </div>
</template>

<script>
  import Nav from '@/components/Global_NavigationHeader';
  import Loader from '@/components/Global_Loader.vue';
  import ImageUpload from '@/components/Global_Image_Upload.vue';
  import TakePicture from '@/components/Global_Image_Capture.vue';
  import getCookie from '@/assets/javascripts/get_cookie';

  const viewHeight =  window.innerHeight - 52;

  export default {
    default_locale: null,
    components: {
      Nav,
      Loader,
      ImageUpload,
      TakePicture,
    },
    data: function() {
      return {
        windowWidth: 0,
        currentRouteComponent: '',
        loaderActive: false,
        galleryUpload: false,
        takeImage: false
      }
    },
    methods: {
      loaderOn: function() {
        this.loaderActive = true;
      },
      loaderOff: function() {
        this.loaderActive = false;
      },
      showGalleryUpload: function() {
        this.$el.classList.add('open')
        this.galleryUpload = true;
      },
      hideGalleryUpload: function() {
        this.$el.classList.remove('open')
        this.galleryUpload = false;
      },
      showTakePicture: function() {
        this.$el.classList.add('open')
        this.takeImage = true;
      },
      hideTakePicture: function() {
        this.$el.classList.remove('open')
        this.takeImage = false;
      },
      widowWidth: function() {
        this.windowWidth = window.innerWidth;
        this.checkContent();
      },
      checkContent: function() {
        var currentComponent = document.getElementById(this.currentRouteComponent);
        var componentHeight = currentComponent.offsetHeight;

        // Account for headers
        if (this.$route.name == 'next-steps') {
          componentHeight += 0;
        } else if (this.windowWidth > 1199) {
          componentHeight += 40;
        } else {
          componentHeight += 45;
        }

        if (componentHeight > viewHeight) {
          document.getElementById('uyh-app').classList.add('clear-height');
        } else {
          document.getElementById('uyh-app').classList.remove('clear-height');
        }
      }
    },
    beforeMount: function() {
      // Read and set language, if preset. Set English if not.
      var lang = getCookie('lang');
      if (lang == "") {
        lang = this.default_locale;
        document.cookie = "lang=" + lang;
      }

      this.$i18n.locale = lang;

      if (!this.$route.path.includes('send-message') && !this.$route.path.includes('share')) {
        document.cookie = 'mantra=expired;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
      }
    },
    beforeCreate: function() {
      let appEl = document.getElementById('uyh-app');
      // grab default locale from element
      this.default_locale = appEl.getAttribute('data-default-locale') || 'en';
      // grab links from element
      let slink = appEl.getAttribute('data-shop-link');
      let elink = appEl.getAttribute('data-events-link');
      if (slink && !getCookie('slink')) { document.cookie = "slink=" + slink; }
      if (slink && !getCookie('elink')) { document.cookie = "elink=" + elink; }
    },
    updated: function() {
      this.$nextTick(function(){
        this.widowWidth();
        window.addEventListener('resize', this.widowWidth);
      });
    },
    watch: {
      $route: function() {
        switch(this.$route.name) {
          case 'landing':
          case 'learn-how':
          case 'get-started':
            this.currentRouteComponent = 'uyh-home';
            break;
          case 'next-steps':
            this.currentRouteComponent = 'next-steps';
            break;
          case 'share':
            this.currentRouteComponent = 'share';
            break;
          case 'mantra-format':
          case 'mantras':
            this.currentRouteComponent = 'mantra-format';
            break;
          case 'send-message':
            this.currentRouteComponent = 'send-message';
            break;
          case 'image-upload':
            this.currentRouteComponent = 'uyh-img-upload';
            break;
        }
      },
    },
    destroyed: function() {
      document.removeEventListener('resize', this.widowWidth);
    }
  }
</script>

<style src="./assets/stylesheets/fonts.css"></style>
<style lang="scss">
// Standalone & KS styles
body {
  background-color: #f8baca;
  padding: 0;
  margin: 0;
}

h1:focus {
  outline: 0 !important;
}

.responsivesite #wrapper #uyh-app,
#uyh-app {
  $mobile-breakpoint: 767px;
  $tablet-portrait-down-breakpoint: 1023px;
  $tablet-down-breakpoint: 1199px;
  $tablet-breakpoint: 1200px;
  $hd-desktop-breakpoint: 1280px;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #FBEAEF;
  color: #22372b;
  font-family: 'FuturaPTMedium', 'Avenir', Helvetica, Arial, sans-serif;
  height: calc(100vh - 52px);
  overflow: hidden;
  position: relative;
  text-align: center;
  width: 100%;
  &.frozen {
    @media screen and (max-width: $tablet-portrait-down-breakpoint) {
      position: fixed;
    }
  }
  &.share {
    background-color: rgba(248, 186, 202, 0.6);
    height: initial;
    min-height: calc(100vh - 52px);
  }
  &.clear-height {
    height: initial;
  }
  &.mantra-page {
    background-color: #e0e9e7;
    height: initial;
    min-height: 640px;
    padding-bottom: 0;
    z-index: 12;
    &.open {
      z-index: 99999;
      top: 0;
    }
    &.image-page {
      background-color: #fceff3;
    }
  }
  &.ar {
    p, li, h1, h2, h3, h4, h5, h6, span {
      direction: rtl;
    }
  }

  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'FuturaPTMedium', 'Avenir', Helvetica, Arial, sans-serif;
    font-weight: 500;
    transition: width 0.3s ease-in-out,
                height 0.3s ease-in-out,
                outline 0.1s ease-in-out,
                outline-offset 0.15s ease-in-out,
                opacity 0.3s ease-in-out,
                background-color 0.3s ease-in-out,
                color 0.3s ease-in-out,
                fill 0.1s ease-in-out,
                transform 0.3s ease-in-out,
                max-width 0.3s ease-in-out;
  }

  [tabindex="-1"] {
    outline: none;
  }

  [class*="uyh-"] {
    color: #22372b;
    font-family: 'FuturaPTMedium';
    font-weight: 500;
    text-transform: none;
    > * {
      color: #22372b;
      font-family: 'FuturaPTMedium';
      font-weight: 500;
      text-transform: none;
    }
  }

  a {
    color: #22372b;
    display: inline-block;
    text-decoration: none;
    &:after {
      background-color: #223628;
      content: '';
      display: block;
      height: 2px;
      position: relative;
      transition: background-color 0.3s ease-in-out;
      width: 100%;
    }
    &:hover {
      color: #fc7ca0;
      &:after {
        background-color: #fc7ca0;
      }
    }
  }

  p {
    margin: 0;
  }

  .uyh-bold,
  .boldweight,
  .uyh-background.textarea h1.boldweight {
    font-family: 'FuturaPTHeavy';
    font-weight: 900;
    letter-spacing: 0.03em;
  }

  button, .uyh-btn {
    cursor: pointer;
    &:hover {
      background-color: #fc7ca0;
      color: #223628;
    }
  }

  .uyh-btn {
    background-color: transparent;
    border-radius: 0;
    border: 1px solid #223628;
    color: #223628;
    cursor: pointer;
    display: inline-block;
    font-size: 20px;
    height: 45px;
    letter-spacing: normal;
    line-height: 45px;
    padding: 0;
    text-align: center;
    text-decoration: none;
    text-transform: none;
    width: 150px;
    &::after {
      display: none;
    }
    &.secondary {
      border: 1px solid #fceff3;
      color: #fceff3;
    }
    &.editor-btn {
      font-size: 15px;
      height: 30px;
      line-height: 30px;
      width: 100px;
    }
    &.small {
      font-size: 14px;
      height: 30px;
      line-height: 30px;
      width: 92px;
    }
    &.active {
      background-color: #ffffff;
    }
    &.mobile-step {
      border: none;
      height: initial;
      line-height: 1;
      width: initial;
      &:after {
        background-color: #223628;
        content: '';
        display: block;
        height: 2px;
        position: relative;
        width: 100%;
      }
    }
  }

  .uyh-back {
    font-size: 20px;
    letter-spacing: 1px;
    line-height: 1;
    margin-left: calc(100vw * 0.047);
    padding: 55px 0 0;
    position: absolute;
    text-align: left;
    @media screen and (min-width: $tablet-breakpoint) and (max-width: $hd-desktop-breakpoint) {
      padding: 30.5px 0 0;
    }

    .uyh-back-arrow {
      height: 15px;
      margin-right: 9.5px;
      width: 9.5px;
    }

    a {
      line-height: 1;
      &:after {
        display: none;
      }
    }
  }
  @media screen and (max-width: $tablet-down-breakpoint) {
    .uyh-back {
      padding: 0;
      position: absolute;
      top: 14px;
      z-index: 1;
      svg {
        path {
          fill: #f8baca;
        }
      }
      span {
        display: none;
      }
    }
  }

  .uyh-background {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;

    h1 {
      font-family: 'FuturaPTMedium';
    }

    &.primary {
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
      margin: 0 auto;
      position: relative;
      &::before {
        display: block;
        content: '';
        padding-top: 100%;
      }
    }

    &.secondary {
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
      position: absolute;
      height: 72.5%;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: calc(58/75 * 100%);
    }

    &.textarea {
      align-items: center;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
      color: #223628;
      display: flex;
      flex-wrap: wrap;
      left: 50%;
      height: 86%;
      padding: 0 15px;
      position: absolute;
      text-align: center;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: calc(242/375 * 100%);

      p, h1, svg {
        flex: 0 0 100%;
      }

      &.border {
        outline: 10px white solid;
        outline-offset: -10px;
      }
      &.alt-1 {
        box-shadow: none;
        padding: 0;
      }
      &.alt-2 {
        height: initial;
        padding: 8%;
        width: calc((100% / 3 * 1.9) + 8%);
        &:before {
          content: '';
          display: block;
          padding-top: 100%;
          position: relative;
        }
        .message-wrapper {
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          width: 84%;
        }
      }

      h1 {
        color: #223628;
        font-stretch: normal;
        font-style: normal;
        left: 50%;
        letter-spacing: normal;
        line-height: 0.92;
        position: relative;
        text-align: center;
        transform: translateX(-50%);
      }

      .uyh-hashtag {
        font-size: 14px;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #223628;
      }
      svg {
        margin: 0 auto;
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .uyh-background {
      &.textarea {
        padding: 30px 15px;
      }
    }
  }
}

// KS global overwrites
.responsivesite #wrapper {
  #uyh-app {
    background-color: #FBEAEF;
    height: calc(100vh - 52px);
    padding-bottom: 40px;
    @media screen and (max-width: 1023px) {
      height: initial;
    }
  }
  .uyh-page {
    background-color: #FBEAEF;
  }
}
</style>
